document.addEventListener('DOMContentLoaded', () => {
  const pdpVideo = document.querySelector('.pdpd-vid');
  if (!pdpVideo) return;

  // Watch all videos in the gallery
  const galleryVideos = document.querySelectorAll('deferred-media video');

  const restartPdpVideo = () => {
    // Small delay so Safari releases the media session
    setTimeout(() => {
      pdpVideo.play().catch(() => {});
    }, 300);
  };

  // MutationObserver for videos that load later (deferred-media)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.tagName === 'VIDEO') {
          node.addEventListener('pause', restartPdpVideo);
          node.addEventListener('ended', restartPdpVideo);
        }
      });
    });
  });

  document.querySelectorAll('deferred-media').forEach((dm) => {
    observer.observe(dm, { childList: true, subtree: true });
  });

  // Fallback: IntersectionObserver - play pdpd-vid when visible and nothing else is playing
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && pdpVideo.paused) {
          pdpVideo.play().catch(() => {});
        }
      });
    },
    { threshold: 0.3 }
  );

  io.observe(pdpVideo);
});
